import { render, staticRenderFns } from "./PublicBlog.vue?vue&type=template&id=1c019e36&scoped=true"
import script from "./PublicBlog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicBlog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PublicBlog.vue?vue&type=style&index=0&id=1c019e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c019e36",
  null
  
)

export default component.exports